import React, {useState, useEffect} from 'react';
import {  Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import DocumentDatatable from './DocumentDatatable';


const DocumentModalWithDatatable = (props) => {
   
    const [t] = useTranslation();
    const [show, setShow] = useState(false);                
    const [entitySubName, setEntitySubName] = useState();
    const [entitySpecify, setEntitySpecify] = useState();  
  

    const handleCallback = (id,subRowId) => {
        setShow(false);     
        props.parentCallback(false,id,subRowId);      
    };
     
    const hideModal = () => {
      setShow(false);       
      props.parentCallback(false,'');  
    };
   
    useEffect(() => {
        setShow(props.modal);
    }, [props.modal])

  

    useEffect(() => {      
      setEntitySubName(props.entitySubName);
    }, [props.entitySubName])

    useEffect(() => {      
      setEntitySpecify(props.entitySpecify);
    }, [props.entitySpecify])

    const handleEntitySpecify  = (entitySpecify) => {
                  
    };

  
   
    return (
 
 
      <>         
                <Modal
                  show={show}
                  onHide={hideModal}
                  container={this}
                  aria-labelledby="contained-modal-title"
                //  centered
                  size="lg"                       //xl                 
                >
                    
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{t('document.label.'+props.entitySpecify+'s')}</Modal.Title>
                  </Modal.Header>
                    <Modal.Body>

                    <DocumentDatatable           
                      parentCallback={handleCallback}                
                      entitySubName={entitySubName}   
                      entitySpecify={entitySpecify} 
                      parentCallbackEntitySpecify={handleEntitySpecify}      
                      checkTime={props.checkTime}      
                      showSelectEntitySpecify={props.showSelectEntitySpecify}                           
                    />     
             
                    </Modal.Body>                   
                                        
                  </Modal>   
      </>
    );
};

 
 export default DocumentModalWithDatatable;


 